<template>
  <layout-animated-underline-component
    class="reset-link font-size-small"
    :to="{ name: 'editions-slug-index-about', params: { slug: item?.slug } }"
    :ignore="item?.slug === $route?.params?.slug ? '' : null"
    :active="item?.slug === $route?.params?.slug ? '' : null"
  >
    <template #default>
      {{ item?.title }}
    </template>
  </layout-animated-underline-component>
</template>

<script setup>
const props = defineProps({
  item: {
    type: Object,
    required: true
  }
})
</script>
